<template>
  <v-layout column justify-center align-center class="mt-4 pt-2">
    <VueCompareImage
      class="hidden-md-and-down"
      hover
      :style="{ minWidth: '1300px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage"
      :rightImage="rightImage"
      :sliderPositionPercentage="sliderPosition"
    />
    <VueCompareImage
      class="hidden-lg-and-up"
      hover
      :style="{ maxWidth: '400px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage2"
      :rightImage="rightImage2"
      :sliderPositionPercentage="sliderPosition"
    />

    <br>

    <vue-typer class="headline" :repeat="0" text="Sunghee Woo"></vue-typer>
    <vue-typer
      :text="text1"
      :repeat="Infinity"
      :shuffle="false"
      initial-action="erasing"
      :pre-type-delay="70"
      :type-delay="70"
      :pre-erase-delay="1980"
      :erase-delay="150"
      erase-style="select-back"
      :erase-on-complete="false"
      caret-animation="smooth"
    ></vue-typer>
    <br>
    <v-flex xs12 sm6 md4 lg4 xl4>
      <v-card flat color="transparent" max-width="500">
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">
              <span>About</span>
              <span class="green--text">Me</span>
            </h3>
            <div>
              <p>
                I am a passionate Data Scientist who carries on 
                <span class="green--text font-weight-bold" >full-stack development</span>.
                
                I have diverse academic and industry experience where I was lucky enough 
                to contribute in various innovative research and software development projects. 
                I enjoy hands-on developments that create values applying 
                
                <span class="green--text font-weight-bold" >Data Science</span>
                and
                <span class="green--text font-weight-bold" >AI/ML</span>.
              </p>
            </div>
          </div>
          
        </v-card-title>
      </v-card>
    </v-flex>

    <!-- LinkedIn v-card -->
    <v-flex xs12 sm6 md4 lg4 xl4>
      <v-card flat color="transparent" max-width="500">
        <v-card-title primary-title class="d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon color="#0A66C2" left>mdi-linkedin</v-icon>
            <span class="headline font-weight-bold ml-2">LinkedIn</span>
          </div>
          <v-btn text color="green" :href="'https://www.linkedin.com/in/sunghee-woo-96185a15/'" target="_blank">
            View Profile
          </v-btn>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueTyper } from "vue-typer";
import VueCompareImage from "vue-compare-image";

export default {
  metaInfo: {
    title: "SungheeWoo",
    titleTemplate: "",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "description", content: "Sunghee Woo's Portfolio" },
      { charset: "utf-8" },
      { property: "og:title", content: "SungheeWoo' Space" },
      { property: "og:site_name", content: "SungheeWoo' Space" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "http://sungheewoo.com" },
      {
        property: "og:image",
        content: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/visual_profile_4.jpg"
      },
      { property: "og:description", content: "Sunghee Woo's Portfolio" }
    ]
  },
  components: {
    "vue-typer": VueTyper,
    VueCompareImage
  },
  data() {
    return {
      text1: ["Data Scientist", "Full-stack Developer"],
      leftImage: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/visual_profile_2.jpg",
      rightImage: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/visual_profile_1.jpg",
      leftImage2: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/visual_profile_3.jpg",
      rightImage2: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/visual_profile_4.jpg",
      sliderLine: 0,
      hSize: 0,
      sliderPosition: 0.5
    };
  }
};
</script>
<style>
@keyframes rocking {
  0%,
  100% {
    transform: rotateZ(-10deg);
  }

  50% {
    transform: rotateZ(10deg);
  }
}

.vue-typer {
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}
.vue-typer .custom.char.typed {
  color: green;
}
.vue-typer .custom.char.selected {
  color: #e91e63;
}

.vue-typer .custom.caret {
  animation: rocking 1s ease-in-out 0s infinite;
}
.vue-typer .custom.caret.typing {
  background-color: green;
}
.vue-typer .custom.caret.selecting {
  display: inline-block;
  background-color: #e91e63;
}
</style>

